var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVu = function SvgIconVu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 12q0-.795-.102-1.565H10.435l-6.92-6.92c-4.687 4.686-4.687 12.284 0 16.97l6.92-6.92h13.463Q24 12.798 24 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.997 12.273-.002.07zM23.985 12.6q0 .035-.004.069zM23.968 12.863l-.007.101zM23.929 10.692l.013.12zM23.98 11.33l.004.069q0-.034-.004-.07M23.995 11.657l.002.07zM23.96 11.035q.006.051.008.102z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M23.898 10.435q.008.06.015.123C23.202 4.611 18.14 0 12 0a11.96 11.96 0 0 0-8.485 3.515l6.92 6.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M23.898 13.565H10.435l-6.92 6.92A11.96 11.96 0 0 0 12 24c6.14 0 11.201-4.61 11.914-10.558z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m23.942 13.188-.013.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.995 12.342"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.99 11.473H9.994l-7.19-7.187a6 6 0 0 0-.64.83l6.876 6.88-6.88 6.88c.135.242.432.6.64.834l7.194-7.193H23.99a12 12 0 0 0-.002-1.044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.915 14.557v-1.005a1.82 1.82 0 0 0 1.82-1.819c0-.71-.578-1.287-1.288-1.287a.88.88 0 0 0-.877.877c0 .31.252.56.561.56a.317.317 0 0 0 .317-.316h1.005c0 .729-.593 1.322-1.322 1.322a1.567 1.567 0 0 1-1.566-1.566c0-1.037.845-1.882 1.882-1.882a2.295 2.295 0 0 1 2.292 2.292 2.827 2.827 0 0 1-2.824 2.824"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconVu;